var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_8819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99163 1.66675C4.39163 1.66675 0.666626 5.40008 0.666626 10.0001C0.666626 14.6001 4.39163 18.3334 8.99163 18.3334C13.6 18.3334 17.3333 14.6001 17.3333 10.0001C17.3333 5.40008 13.6 1.66675 8.99163 1.66675ZM8.99996 16.6667C5.31663 16.6667 2.33329 13.6834 2.33329 10.0001C2.33329 6.31675 5.31663 3.33341 8.99996 3.33341C12.6833 3.33341 15.6666 6.31675 15.6666 10.0001C15.6666 13.6834 12.6833 16.6667 8.99996 16.6667Z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41663 5.83325H8.16663V10.8333L12.5416 13.4583L13.1666 12.4333L9.41663 10.2083V5.83325Z",
    fill: "#6D6E71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_8819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/access_time.bf29a953d02e50150de317b9e196334e.svg";
export { ForwardRef as ReactComponent };